import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-transaction",
  "use": "icon-transaction-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-transaction\"><defs><style type=\"text/css\"></style></defs><path d=\"M513 63.8c-246.5 0-446.3 199.8-446.3 446.3S266.5 956.4 513 956.4s446.3-199.8 446.3-446.3S759.5 63.8 513 63.8z m163.4 297.4L596.6 441h34.9c19.1 0 34.6 15.5 34.6 34.6s-15.5 34.6-34.6 34.6h-83.9v44.2h83.9c19.1 0 34.6 15.5 34.6 34.6s-15.5 34.6-34.6 34.6h-83.9v96c0 19.1-15.5 34.6-34.6 34.6s-34.6-15.5-34.6-34.6v-96h-83.9c-19.1 0-34.6-15.5-34.6-34.6s15.5-34.6 34.6-34.6h83.9v-44.2h-83.9c-19.1 0-34.6-15.5-34.6-34.6s15.5-34.6 34.6-34.6h34.9l-79.8-79.8c-13.5-13.5-13.5-35.4 0-49 13.5-13.5 35.4-13.5 49 0L513 426.7l114.4-114.4c13.5-13.5 35.4-13.5 49 0 13.5 13.5 13.5 35.4 0 48.9z\" p-id=\"20342\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/transaction.svg
// module id = oP+6
// module chunks = 7